<template>
    <div v-if="disabled">

    </div>
    <div v-else>
    <v-menu
        max-width="80%"
        v-model="dateMenu"
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                class="datePickerText"
                solo
                flat
                :value="formattedDate"
                readonly
                dense
                :persistent-placeholder="true"
                placeholder="Bitte Datumsbereich wählen"
                @click="dateMenu = !dateMenu"
                v-bind="attrs"
                v-on="on">
                <template v-slot:prepend-inner>
                    <v-icon small class="mr-2">fa-sharp fa-calendar</v-icon>
                </template>
                <template v-slot:append-outer>
                    <v-icon class="mt-1" @click="dateMenu=!dateMenu">fa-caret-down</v-icon>
                </template>
            </v-text-field>
        </template>
        <v-date-picker
            :first-day-of-week="firstDayOfWeek"
            range
            locale="de"
            locale-first-day-of-year="1"
            style="display: flex; width: unset;"
            class="posManagerDateRangePicker"
            :max="maxDate"
            v-model="dates"
            :title-date-format="()=>formattedDate"
        >
        </v-date-picker>
    </v-menu>
    </div>
</template>
<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import moment from "moment-mini";

@Component({components: {}})
export default class DateRangePicker extends Vue {

    @Prop({default: false}) disabled!: boolean;
    private dates: string[] = [];
    private formattedDate: string = '';
    private dateMenu: boolean = false;

    @Watch('dates', { deep: true})
    private dateChanged(): void {
       if(this.dates && this.dates.length === 2) {
           this.dateMenu = !this.dateMenu;
           let newDates = JSON.parse(JSON.stringify(this.dates));
           let dateFormat='';

          const datesSort = newDates.sort(DateRangePicker.dateComparison);
           newDates.forEach((d:any) => {
               dateFormat += moment(d).format("DD.MM.YYYY") + " - ";
           });
           this.formattedDate = dateFormat.substr(0,dateFormat.length - 2);
           this.$emit("dateRangeChanged",{ start:datesSort[0], end: datesSort[1], title: this.formattedDate});
       }
    }

    private static dateComparison(a:any, b:any) {
        const date1 = moment(a);
        const date2 = moment(b);

        return  date1.toDate().valueOf() - date2.toDate().valueOf();
    }

    private get firstDayOfWeek(): number {
        return 1;
    }

    constructor() {
        super();
    }

    mounted() {

    }

    private get maxDate(): string {
        return moment(new Date()).format("YYYY-MM-DD");
    }
}
</script>
<style>

</style>
